/**
 * Detects the base URL from script tags
 * @returns {string} The base URL
 */
export const detectBaseUrl = () => {
    const scripts = document.getElementsByTagName("script");
    let baseUrl = window.location.origin;

    for (let script of scripts) {
        if (script.src.includes("recomdo.ai/voice-search")) {
            baseUrl = new URL(script.src).origin;
            break;
        }
    }

    return baseUrl;
};

/**
 * Checks if the device is iOS
 * @returns {boolean} True if the device is iOS
 */
export const isIOSDevice = () => {
    const userAgent = window.navigator.userAgent.toLowerCase();
    return /iphone|ipad|ipod/.test(userAgent);
};

/**
 * Checks if the device is iOS
 * @returns {boolean} True if the device is iOS
 */
export const isAndroid = () => {
    const userAgent = window.navigator.userAgent.toLowerCase();
    return /android/i.test(userAgent);
};
/**
 * Checks if the device is mobile based on screen width
 * @returns {boolean} True if the device is mobile
 */
export const isMobileDevice = () => {
    return window.innerWidth <= 640;
};

/**
 * Sets up a resize event listener to detect mobile devices
 * @param {Function} setIsMobile - State setter function for isMobile
 * @returns {Function} Cleanup function to remove event listener
 */
export const setupMobileDetection = (setIsMobile) => {
    const handleResize = () => {
        setIsMobile(isMobileDevice());
    };

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => {
        window.removeEventListener("resize", handleResize);
    };
};
